import React from 'react';
import IconStart from '@learningblocks/exp-constants/lib/Icons/start-solid';
import {Colours} from '@learningblocks/storybook-components';

const START_ICON_STYLE = {
  color: Colours.colorNeutralGray1,
  height: '16px',
  top: '2px',
};

export function StartIcon() {
  return <IconStart style={START_ICON_STYLE} />;
}
